import React from 'react';
import { observer } from 'mobx-react';
import Logout from '../auth/Logout';
import { NavLink } from 'react-router-dom';
import { CaretDown } from '../Icons';
import { useStores } from '../../hooks/useStores';

/**
 * Render username with dropdown in the top-right of the page.
 *
 * The auth store was injected with mobx-react (`inject(({ store }) => ({ auth:
 * store.auth }))`); it now comes from useStores(). The class was wrapped in
 * withRouter but never read any router prop, so the shim is dropped.
 */
const AccountDropdown = observer(function AccountDropdown() {
  const store = useStores();
  const auth = store.auth;

  return (
    <div className="group relative flex cursor-pointer px-[30px] py-[17px] leading-[26px]">
      <div className="username">{auth.user!.name}</div>
      <div className="mx-[10px]">
        <div className="px-[5px] text-[30px] leading-[17px] text-grey2">
          <CaretDown className="h-4 w-4" />
        </div>
        <div className="absolute inset-x-0 top-full z-20 hidden shadow-[0_6px_12px_-4px_rgba(0,0,0,0.2)] group-hover:block [&_a.active:hover]:bg-white [&_a.active]:italic [&_a.active]:text-grey [&_a:hover]:bg-[#f5f7fa] [&_a:hover]:text-primary [&_a]:block [&_a]:cursor-pointer [&_a]:bg-white [&_a]:px-[30px] [&_a]:py-[10px] [&_a]:text-left [&_a]:text-[1em] [&_a]:font-normal [&_a]:text-black [&_a]:no-underline [&_button:hover]:bg-[#f5f7fa] [&_button:hover]:text-primary [&_button]:block [&_button]:w-full [&_button]:cursor-pointer [&_button]:bg-white [&_button]:px-[30px] [&_button]:py-[10px] [&_button]:text-left [&_button]:text-[1em] [&_button]:font-normal [&_button]:text-black [&_button]:no-underline">
          <NavLink end to="/account">
            Account
          </NavLink>
          <NavLink end to="/">
            Dashboard
          </NavLink>
          <Logout />
        </div>
      </div>
    </div>
  );
});

export default AccountDropdown;
